// BrimLight/client/widgets/ProjectGalleryWidget.js

export default {
    name: "ProjectGalleryWidget",
    type: "ProjectGallery", // This should match the class name of the UI component
    description: "Displays a gallery of the user's video projects.",
    roles: ["appUser"], // Only visible to logged-in users
    widget: {
        title: "My Projects",
        size: "large", // Or 'full' if it should take the whole width
        // No dataProvider needed here as the component handles its own data fetching
    }
};